const API_BASE_URL = import.meta.env.VITE_API_URL || "http://localhost:3001/api";
class ApiClient {
    baseUrl;
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    async request(endpoint, options = {}) {
        const url = `${this.baseUrl}${endpoint}`;
        const headers = {
            "Content-Type": "application/json",
            ...options.headers,
        };
        try {
            const response = await fetch(url, {
                ...options,
                headers,
            });
            const data = await response.json();
            if (!response.ok) {
                return {
                    ok: false,
                    error: {
                        code: "API_ERROR",
                        message: data.error?.message || "An error occurred",
                    },
                };
            }
            return data;
        }
        catch (error) {
            return {
                ok: false,
                error: {
                    code: "NETWORK_ERROR",
                    message: "Failed to connect to server",
                },
            };
        }
    }
    async get(endpoint) {
        return this.request(endpoint, { method: "GET" });
    }
    async post(endpoint, body) {
        return this.request(endpoint, {
            method: "POST",
            body: JSON.stringify(body),
        });
    }
    async put(endpoint, body) {
        return this.request(endpoint, {
            method: "PUT",
            body: JSON.stringify(body),
        });
    }
    async delete(endpoint) {
        return this.request(endpoint, { method: "DELETE" });
    }
}
export const apiClient = new ApiClient(API_BASE_URL);
